import Vue from 'vue';

import Vuetify from 'vuetify/lib';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';

import { WxConfirmPlugin, WxHasPlugin, WxRequestPlugin, WxI18nPlugin, WxRouterPlugin } from 'wax-lib';

import { routes } from '@/main-routes';
import store from '@/main-store';
import main from '@/components/main.vue';

Vue.config.productionTip = false;

Vue.config.errorHandler = (err, vm, info) => {
    Vue.prototype.$log.error(err, vm, info);
};

Vue.config.warnHandler = (msg, vm, info) => {
    Vue.prototype.$log.warn(msg, vm, info);
};

// SOURCE: https://vuetifyjs.com/en/framework/internationalization
export const vuetify = new Vuetify({
    lang: {
        t: (key: any, ...params: any) => i18n.t(key, params),
    },
});

Vue.use(Vuetify);
Vue.use(WxHasPlugin, { privileges: () => store.getters.privilegeIds });
Vue.use(WxConfirmPlugin, { vuetify });
Vue.use(WxRequestPlugin, {
    baseURL: '/datasling/execute/',
    hndlRequestError: (message: string) => store.commit('error', message),
    hndlWafError: (code: string, message: string) => store.commit('error', `${code} - ${message}`),
    hndlWafMessage: (message: string) => store.commit('addMessage', message),
    getSessionId: () => store.getters.sessionid,
});
const router = new WxRouterPlugin({ routes, privileges: () => store.getters.privilegeIds, isAuthenticated: () => store.getters.isAuthenticated });
Vue.use(WxRouterPlugin);
const wxI18nPlugin = new WxI18nPlugin();
Vue.use(wxI18nPlugin, { localeResource: () => store.getters.localeResource });
const i18n = wxI18nPlugin.instance();

const App = new Vue({
    vuetify,
    i18n,
    router,
    store,
    render: (h) => h(main),
}).$mount('#app');
